import "core-js/modules/es.array.filter";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import _variables from '@/styles/variables.scss';
export default {
  name: 'App',
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState({
    permission_routes: function permission_routes(state) {
      return state.permission.routes.filter(function (item) {
        return !item.hidden;
      });
    }
  })), mapGetters(['loginAccount', 'sidebar', 'superAdminFlag'])), {}, {
    activeMenu: function activeMenu() {
      var e = this.$route.matched.length === 0 ? this.$route.path : this.$route.matched[0].path;
      this.handleSelect(e);
      return e || '/';
    },
    variables: function variables() {
      return _variables;
    }
  }),
  created: function created() {
    window.onscroll = function () {
      var top_left = document.body.scrollLeft || document.documentElement.scrollLeft || window.pageXOffset;
      if (document.querySelector('.right-menu')) document.querySelector('.right-menu').style.marginRight = top_left + 'px';
    };
  },
  methods: {
    handleSelect: function handleSelect(key) {
      var temp = this.permission_routes.filter(function (item) {
        return item.path === key;
      });
      temp.length && this.$store.commit('permission/SET_SIDEBAR_ROUTES', temp[0].children);
    },
    // 回首页
    backToHome: function backToHome() {
      this.$router.push('/');
    },
    changePass: function changePass() {
      this.$refs.changePass.show();
    },
    logout: function logout() {
      var _this = this;

      this.$confirm('确定要退出当前账号?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('user/logout');

              case 2:
                _this.$router.push('/login');

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};